import { Badge } from '@chakra-ui/react';
import type { ReactNode } from 'react';

/** Store connection or platform declaration, shared by the panel and summary. */
export const StatusBadge = ({
  tone,
  children,
}: {
  tone: 'ok' | 'todo' | 'neutral';
  children: ReactNode;
}) => (
  <Badge flex="none" colorPalette={tone === 'ok' ? 'green' : tone === 'todo' ? 'yellow' : 'gray'}>
    {children}
  </Badge>
);
